// src/components/profile/UserCategories.jsx
import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Chip,
  Paper,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  useTheme
} from '@mui/material';
import CategoryIcon from '@mui/icons-material/Category';
import { useCategories } from '../../context/CategoryContext';
import { useTranslation } from 'react-i18next';

const UserCategories = ({ userListings }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { categoriesList } = useCategories();
  const [userCategories, setUserCategories] = useState([]);

  useEffect(() => {
    if (userListings && userListings.length > 0 && categoriesList && categoriesList.length > 0) {
      // Extraire les IDs de catégories uniques des annonces de l'utilisateur
      const categoryIds = [...new Set(userListings.map(listing => listing.categoryId))];
      
      // Trouver les objets de catégorie correspondants
      const categories = categoryIds
        .map(id => categoriesList.find(cat => cat.id === id))
        .filter(Boolean); // Filtrer les undefined
      
      setUserCategories(categories);
    }
  }, [userListings, categoriesList]);

  if (!userCategories || userCategories.length === 0) {
    return (
      <Paper sx={{ p: 2, mb: 3, borderRadius: 2 }}>
        <Typography variant="h6" gutterBottom>
          {t('common.usedCategories', 'Catégories utilisées')}
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <Typography variant="body2" color="text.secondary">
          {t('common.noCategoriesListed', "Aucune catégorie n'est associée à vos annonces.")}
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper sx={{ p: 2, mb: 3, borderRadius: 2 }}>
      <Typography variant="h6" gutterBottom>
        {t('common.usedCategories', 'Catégories utilisées')}
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <List>
        {userCategories.map(category => (
          <ListItem key={category.id} sx={{ py: 1 }}>
            <ListItemIcon>
              <CategoryIcon color="primary" />
            </ListItemIcon>
            <ListItemText 
              primary={category.name}
              secondary={category.description || t('common.noDescription', 'Aucune description')}
            />
            <Chip 
              label={`${userListings.filter(l => l.categoryId === category.id).length} ${t('common.listingWord', 'annonce(s)')}`}
              size="small"
              color="primary"
              variant="outlined"
            />
          </ListItem>
        ))}
      </List>
    </Paper>
  );
};

export default UserCategories;